<div class="col-12">
    <div class="history">
        <div class="history__header">
            <div class="row">
                <div class="col-12 col-sm-4">
                    <h1>All Uploaded Files</h1>
                </div>
                <div class="col-12 col-sm-8">
                    <div class="row">
                        <div class="col-12 col-sm-8">
                            <atram-textbox [parentFormGroup]="searchFormGroup"
                                            type="text"
                                            controlName="searchField"
                                            label="Search for"
                                            placeholder="Search for"    
                                            [isRequired]="true"
                                            [showSearchButton]="true"
                                            (on-click)="getDocuments()">
                            </atram-textbox>
                        </div>
                        <div class="col-12 col-sm-4">
                            <atram-daterangepicker [parentFormGroup]="searchFormGroup"
                                            type="text"
                                            controlName="searchDate"
                                            label="Search Date"
                                            placeholder="Search Date"    
                                            [isRequired]="true">
                            </atram-daterangepicker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="history__body">
            <div class="result">
                <div class="row result__headers">
                    <div class="col-3">
                        <p>Uploader</p>
                    </div>
                    <div class="col-3">
                        <p>File Name</p>
                    </div>
                    <div class="col-2">
                        <p>Type</p>
                    </div>
                    <div class="col-2">
                        <p>Date and Time</p>
                    </div>
                    <div class="col-2">
                        <p>File Size</p>
                    </div>
                </div>
                <hr>  
                <ng-container *ngFor="let file of historyList | paginate: config">
                    <div class="row result__body">
                        <div class="col-3">
                            <p data-title="{{file.uploader}}">{{file.uploader}}</p>
                        </div>
                        <div class="col-3">
                            <p data-title="{{file.file_name}}">{{file.file_name}}</p>
                        </div>
                        <div class="col-2">
                            <p>{{file.document_type}}</p>
                        </div>
                        <div class="col-2">
                            <p>{{file.created_date | date: 'MM/dd/yyyy | h:mm:ss a'}}</p>
                        </div>
                        <div class="col-2">
                            <p>{{file.file_size}}</p>
                        </div>  
                    </div>
                    <hr>    
                </ng-container>
            </div>
            <pagination-template #p="paginationApi"
                     [id]="config.id"
                     (pageChange)="getPage($event)">
                <div class="custom-pagination atram-paginate">
                    <div class="atram-paginate__content">
                        <div class="row justify-content-center atram-paginate__cont text-center">
                            <div *ngIf="!p.isFirstPage()" class="pagination-previous atram-paginate__box" [class.disabled]="p.isFirstPage()">
                                <span (click)="p.previous()"> < </span>
                            </div>

                            <div class="atram-paginate__box" *ngFor="let page of p.pages" [class.atram-paginate__box--selected]="p.getCurrent() === page.value">
                                    <span (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">{{ page.label }}</span>
                                <div *ngIf="p.getCurrent() === page.value">
                                    <span>{{ page.label }}</span>
                                </div>
                            </div>
                            <div *ngIf="!p.isLastPage()" class="pagination-next atram-paginate__box" [class.disabled]="p.isLastPage()">
                                <span (click)="p.next()"> > </span>
                            </div>
                            <div class="f-form_input col-2" style="max-width:130px;">
                                <atram-select [parentFormGroup]="searchFormGroup"
                                                type="text"
                                                controlName="pageSize"
                                                label="Page Size"
                                                placeholder="Page Size"    
                                                [isRequired]="true"
                                                [options]="searchOptions"
                                                (on-select)="setPageSize()">
                                </atram-select>
                            </div>
                        </div>
                    </div>
                </div>
            </pagination-template>
            <!-- <div class="atram-paginate">
                <div class="atram-paginate__content">
                    <div class="row justify-content-center atram-paginate__cont text-center">
                        <div *ngIf="pageCount > 1 && currentPage > 1" (click)="searchDocuments(currentPage-1)" class="atram-paginate__box">
                            <span><b><</b></span>
                        </div>
                        <div *ngIf="pageCount > 1 && currentPage <= 1" class="atram-paginate__box atram-paginate__box--disable">
                            <span style="opacity:.3;"><b><</b></span>
                        </div>
                        <ng-container *ngFor="let _ of [].constructor(pageCount); let i = index;">
                            <ng-container *ngIf="((currentPage+3 >= i) && !(currentPage > i+1))">
                                <div [ngClass] = 'selectedPage === i+1 ? "atram-paginate__box--selected" : ""' class="atram-paginate__box" (click)="searchDocuments(i+1)">
                                    <span>{{i+1}}</span>
                                </div>
                            </ng-container>
                        </ng-container>
                        <div *ngIf="pageCount > 1 && !(currentPage >= pageCount)" class="atram-paginate__box" (click)="searchDocuments(currentPage+1)">
                            <span><b>></b></span>
                        </div>
                        <div *ngIf="pageCount > 1 && currentPage >= pageCount" class="atram-paginate__box atram-paginate__box--disable">
                            <span style="opacity:.3;"><b>></b></span>
                        </div>
                        <div class="f-form_input col-2" style="max-width:130px;">
                            <atram-select [parentFormGroup]="searchFormGroup"
                                            type="text"
                                            controlName="pageSize"
                                            label="Page Size"
                                            placeholder="Page Size"    
                                            [isRequired]="true"
                                            [options]="searchOptions"
                                            (on-select)="searchDocuments(1)">
                            </atram-select>
                        </div>
                    </div> 
                </div> 
            </div> -->
        </div>
    </div>
</div>